module.exports = __webpack_public_path__ + "media/favicon/safari-pinned-tab-1bba806b177634bc6cebada7f203e6b3.svg";